<template>
  <div class="signin-bg">
    <Header></Header>
    <search-header></search-header>
    <!--详情-->
    <div class="detail">
      <div class="w-1200">
        <h2 class="commonmin">
          <a href="javascript:;">首页</a>
          <span>&gt;</span>
          <router-link
            v-if="searchActive == '矢量图'"
            :to="{ name: 'Vector' }"
            >{{ searchActive }}</router-link
          >
          <router-link v-else :to="{ name: 'Photography' }">{{
            searchActive
          }}</router-link>
          <span>&gt;</span>
          <a href="javascript:;">图片</a>
        </h2>
        <div class="img-detail flbt">
          <div class="imgcon-left">
            <div class="imgcon-img">
              <img :src="photoDetail.thumbnail" />
                <div class="imgcon-img-cover">
                    <div @click="dialogVisible = true">
                        查看大图
                    </div>
                    <div @click="org = true">
                        嵌套模型
                    </div>
                </div>
            </div>
            <div class="scjb hd">
              <div class="shouc" @click="collection(photoDetail.thumbnail)">
                <i class="bg"></i>
                <span>收藏保存</span>
              </div>
              <div class="jubao" @click="report()">
                <i></i>
                <span>举报该图片</span>
              </div>
            </div>
            <div
              class="infoClassText"
              v-if="photoDetail.file_type == '摄影图片(新闻类)'"
            >
              新闻类图片仅限于新闻传播，禁止用于商业/广告/宣传等商业用途！
            </div>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="photoDetail.thumbnail_org" @click="imgZoomOut" />
            </el-dialog>
          </div>
          <div class="imgcon-right">
            <h2 class="img-name">{{ photoDetail.description_cn }}</h2>
            <div class="xinxi">
              <span>素材ID：{{ photoDetail.id }}</span>
              <span v-if="photoDetail.source === 'bestview'" style="font-size: 12px; color: #0e0e0e">本作品有售价保护，如需购买，请联系客户经理</span>
              <span>素材类型：{{ photoDetail.media_type }}</span>
              <span>文件类型：{{ searchActive }}</span>
              <span v-if=" contributor_handle == '' ">摄影师：{{ photoDetail.realname }}</span>
              <span v-if=" contributor_handle != '' ">摄影师：
                  <router-link style="text-decoration: underline;color: #999" :to="{name:'Search_author',
                  query:{
                      contributor_handle:contributor_handle,
                      author:photoDetail.realname
                  }}" target="_blank">
                      {{ photoDetail.realname }}
                  </router-link>
              </span>
              <span v-if="photoDetail.ispower"
                >模特肖像权：是
                <span class="detail-bubble"
                  ><span class="solt_contnet"
                    >模特版权，是一份由模特签署的法律文件并授予照片肖像摄影版权以分布、分发、使用他或她在一张或其他照片肖像。</span
                  >
                </span>
              </span>
            </div>
            <div class="img-tab">
              <ul class="tab_title hd">
                <li v-for="(item, index) in purposeTitle" :key="index">
                  <p
                    @click="changeTab($event)"
                    :data-num="index + 1"
                    :data-id="item[0]"
                  >
                    {{ item[1] }}<i :class="{ blk: tabIndex == index + 1 }"></i>
                  </p>
                </li>
              </ul>
              <div class="tab-list">
                <div
                  class="list-cont"
                  v-for="(item, index) in purposeSize"
                  :key="index"
                  :style="{ display: tabIndex == index + 1 ? 'block' : 'none' }"
                >
                  <form>
                    <div v-for="(v, k) in item" :key="k">
                      <label v-if="v.res" class="checkLabel">
                        <input
                          type="radio"
                          name="sjmt"
                          :value="k"
                          v-model="sizeType"
                        />
                        <i></i>
                        <span class="ma">{{ v.res.toUpperCase() }}</span>
                        <span
                          v-if="v.output_width == 'unlimited'"
                          class="unlimited"
                          >可随意缩放且不影响画质</span
                        >
                        <template v-else>
                          <span class="danweipx"
                            >{{ v.width }}x{{ v.height }}px</span
                          >
                          <span class="danweicm"
                            >{{ v.output_width }}x{{ v.output_height }}cm</span
                          >
                        </template>
                        <span class="dpi">{{ v.dpi }}dpi</span>
                        <span class="geshi">{{ v.format }}</span>
                      </label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="download ct" id="download">
              <a href="javascript:;" class="xiazai" @click="showZtyi()">下载</a>
              <a
                href="javascript:;"
                class="xiaoyang"
                :disabled="samplerecordBtn"
                @click="samplerecord()"
                v-if="photoDetail && !photoDetail.id.includes('P')"
                >下载小样</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--关键词相关推荐-->
    <div class="xiangguan">
      <div class="w-1190">
        <div class="gjc-btm"  style="display: none">
          <div class="detail-title">
            <p>关键词</p>
            <div
              v-if="photoDetail.source === ''"
              class="translation-btn"
              @click="translateKeywords"
            >
              {{ translationBtnText }}
            </div>
          </div>
          <div class="gjc-contbg hd">
            <ul>
              <li v-for="(item, index) in keywords" :key="index">
                <a href="javascript:;" v-if="!isLoginSearch">{{ item }}</a>
                <router-link v-if="isLoginSearch"
                        :to="{
                    name: 'Search',
                    query: { keyword: item, mediaType: 1 },
                  }"
                        target="_blank"
                >{{ item }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="tuijian">
          <div class="detail-title">
            <p>相似图片</p>
            <p></p>
          </div>
          <!--图片瀑布流-->
          <!--   <div class="pubu-img">
                        <div v-for="(item,index) in photoSimilar" :key="index">
                            <router-link :to="{name:'Photo',query:{id:item.id}}" target="_blank">
                                <img :src="item.thumbnail" />
                            </router-link>
                        </div>

                    </div>-->

          <div class="pubu-img">
            <ul>
              <li v-for="(item, index) in photoSimilar" :key="index"  :style="{width:(200/item.height)*item.width + 'px',background:'#bbbbbb'}">

                      <router-link
                          :to="{ name: 'Photo', query: { id: item.id } }"
                          target="_blank"
                      >
                          <img :src="item.thumbnail" />
                      </router-link>


              </li>
            </ul>
          </div>
          <loading v-if="isLoad"></loading>
        </div>
      </div>
    </div>
    <!--弹窗框-->
    <!--遮罩层-->
    <div class="overCurtain" v-show="overCurtain"></div>
    <!--以下有三个弹窗区域根据不同状态判断显示的弹窗区域-->
    <!--默认显示第一个状态-->
    <!--第一个状态-->
    <div class="zhuangtaiqu ztyi" v-show="ztyi">
      <p class="hd">
        <img
          src="../assets/search/close.png"
          class="close fr"
          alt=""
          @click="(overCurtain = false), (ztyi = false)"
        />
      </p>
      <div class="souquan">
        <p>请选择被授权方</p>
        <div class="hd">
          <input
            type="text"
            placeholder="填写被授权方名称"
            v-model="getAuthorisationFrom.keyword"
            class="tianxiesq fl"
          />
          <span type="button" class="serch-btn fl">
            <img
              src="../assets/search/serch.png"
              alt=""
              @click="getAuthorisationData()"
            />
          </span>
          <span class="tjsq" @click="(ztyi = false), (zter = true)"
            >添加被授权方</span
          >
        </div>
        <div class="price-tip">本次下载需消耗额度{{sizePrice}}</div>
        <div class="sqgs">
          <form>
            <label class="checkLabel">
              <input
                type="radio"
                name="sqnm"
                checked=""
                value="0"
                v-model="authorisedEntityId"
              />
              <i></i>
              <span class="gsname">{{ company.name }}</span>
              <span class="zhuansq">被授权主体</span>
            </label>

            <label class="checkLabel" v-for="i in list.result" :key="i.id">
              <input
                type="radio"
                name="sqnm"
                :value="i.id"
                checked=""
                v-model="authorisedEntityId"
              />
              <i></i>
              <span class="gsname">{{ i.title }}</span>
              <span class="zhuansq">转授权</span>
            </label>
          </form>
        </div>
        <div class="queding">
          <a href="javascript:;" @click="downloadRecord()">{{ downloadText }}</a>
        </div>
      </div>
    </div>
    <!--第二个状态-->
    <div class="zhuangtaiqu zter" v-show="zter">
      <p class="hd">
        <img
          src="../assets/search/close.png"
          class="close fr"
          alt=""
          @click="showZtyi()"
        />
      </p>
      <input
        type="text"
        placeholder="填写被授权方名称"
        v-model="addAuthorisationFrom.title"
        class="tianxiesq-tow fl"
      />
      <div class="queding">
        <a href="javascript:;" @click="addAuthorisation()">确定</a>
      </div>
    </div>
    <!--第三个状态-->
    <div class="zhuangtaiqu ztsan" v-show="ztsan">
      <div class="sorry">
        <p>抱歉！</p>
        <p>{{ ztsan_mssage }}</p>
      </div>
      <div class="queding">
        <a
          href="javascript:;"
          class="close"
          @click="(overCurtain = false), (ztsan = false), (ztyi = false)"
          >确定</a
        >
      </div>
    </div>
    <div v-if="downloading" class="progress">
      <el-progress :text-inside="true" color="#ff9f00" :stroke-width="20" :percentage="downloadingProgress"></el-progress>
    </div>
      <Thumbnail v-if="org" v-bind:thumbnail="photoDetail.thumbnail"></Thumbnail>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
import SearchHeader from "./SearchHeader";
import { download } from "@/util/common";
import Thumbnail from "./Thumbnail";
import {getCookie} from "../util/common";

export default {
  name: "Photo",
  components: {
      Thumbnail,
    Header,
    Footer,
    SearchHeader,
  },
  data() {
    return {
      isLoginSearch:false,
      dialogVisible: false,
      searchActive: "",
      mediaType: 1,
      id: 1067653527,
      tabIndex: 1,
        org:false,
      photoDetail: [],
      photoSimilar: [],
      purposeTitle: [],
      purposeSize: [],
      samplerecordBtn: false,
      overCurtain: false,
      ztyi: false,
      zter: false,
      ztsan: false,
      ztsan_mssage: '',
      downloadText: '确定',
      list: [],
      company: {},
      addAuthorisationFrom: {},
      getAuthorisationFrom: {
        page: 1,
        per_page: 50,
        keyword: "",
      },
      purposeId: 1,
      sizeType: "",
      sizePrice: 0,
      authorisedEntityId: 0,
      isLoad: false,
      keywords:'',
        contributor_handle:'',
      keywordss:'',
      translationBtnText: "翻译英文",
      translationType: 1,
      translationCN: "",
      downloadingProgress: 0,
        mediaTypes:'',
      downloading: false,
        user_name:'',
        user_id:'',
        name:'',
        email:'',
        contact_person:'',
        page_type:2,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.mediaType = this.$route.query.mediaType;
    this.keywordss = this.$route.query.keyword;
    this.source_page = window.location.href;
    let token = getCookie('token')
    if(token) {
      this.isLoginSearch = true;
    }
      this.$get('/me')
          .then( res => {
              if(res.code == 200){
                  this.user_name = res.data.user.user_name
                  this.user_id = res.data.user.id
                  this.name = res.data.user.name
                  this.email = res.data.user.email
                  this.contact_person = res.data.user.contact_person
                  let data = {
                      keywords:this.keywords,
                      user_id:this.user_id,
                      type:this.mediaType,
                      page_type:this.page_type,
                  }
                  this.$post('/es/touchDetail',data)
                      .then( res => {
                      }).catch(errors => {
                      console.log(errors);
                  })
              }
          }).catch(error => {
          console.log(error)
      })

  },
  mounted() {
    this.getPhotoDetail();
    this.getPhotoSimilar();
    this.browseHistory();
  },
  methods: {
    downloadRecord() {
      let downloadData = {
        mediaId: this.id,
        authorisedEntityId: this.authorisedEntityId,
        purposeId: this.purposeId,
        sizeType: this.sizeType,
      };
      console.log(this.downloadText)
      if (this.downloadText == "确定") {
        this.downloadText = '下载中...'
        this.$post("/downloadrecord/save", downloadData).then((res) => {
          if (res.code == 200 && res.status === "success") {
            let data2 = {
              keywords:this.keywordss,
              user_name:this.user_name,
              user_id:this.user_id,
              img_id:this.id,
              source_page:this.source_page,
              size:this.sizeType,
              img_type:this.mediaTypes,
              img_url:this.photoDetail.thumbnail,
              name:this.name,
              email:this.email,
              contact_person:this.contact_person,
            }
            this.$post('/es/download',data2)
                    .then( res => {
                    }).catch(errors => {
              console.log(errors);
            })
            // window.location.href =
            if (this.photoDetail.source === "") {
              window.location.href = res.data.download_url;
            } else {
              const downloadDialog = this.$message({
                message: "开始下载，请稍候...",
                type: "success",
                duration: 0,
              });
              download(res.data.download_url, {
                onProgress: (loaded, total, e) => {
                  this.overCurtain = true;
                  this.downloading = true;
                  console.log(loaded, total, e);
                  this.downloadingProgress = Math.floor((loaded / total) * 100);
                },
              }).then(() => {
                this.downloading = false;
                this.overCurtain = false;
                downloadDialog.close();
                console.log(downloadData, "成功");
              })
            }
            this.overCurtain = false;
            this.ztyi = false;
          } else {
            this.overCurtain = true;
            this.ztyi = false;
            this.ztsan = true;
            this.ztsan_mssage = res.message
          }
          this.downloadText = '确定'
        });
      }

    },
      org_close(){
          this.org = false
      },
    addAuthorisation() {
      this.$post("/authorisation", this.addAuthorisationFrom).then((res) => {
        if (res.code === 200 && res.status === "success") {
          this.showDialog = false;
          this.$message({
            showClose: true,
            message: res.data,
            type: "success",
          });
          this.showZtyi();
        }
      });
    },
    showZtyi() {
      if (!this.getCookie('token')) {
        this.$message({
          message: "请先登录",
          type: "error",
          duration: 1000,
          onClose: () => {
            this.$router.push({name:'Login'})
          }
        });
        return;
      }
      if (this.sizeType == "") {
        this.$message({
          message: "请先选择尺寸",
          type: "error",
        });
        return;
      }
      this.sizePrice = this.purposeSize[this.tabIndex - 1][this.sizeType]['size_price']
      this.overCurtain = true;
      this.ztyi = true;
      this.zter = false;
      this.ztsan = false;
      this.getAuthorisationData();
    },
    getAuthorisationData() {
      this.$get("/authorisation", this.getAuthorisationFrom).then((res) => {
        if (res.code === 200 && res.status === "success") {
          this.list = res.data.entities;
          this.company = res.data.company;
        }
      });
    },
    samplerecord() {
      if (!this.getCookie('token')) {
        this.$message({
          message: "请先登录",
          type: "error",
          duration: 1000,
          onClose: () => {
            this.$router.push({name:'Login'})
          }
        });
        return;
      }
      this.samplerecordBtn = true;
      const params = { mediaId: this.id }
      if (this.searchActive === '矢量图片') { // 增加下载eps小样图
        params['type'] = 'vendor'
      }
      // console.log(params)
      this.$post("/samplerecord/save", params).then((res) => {
        if (res.code == 200 && res.status === "success") {
          window.location.href = res.data.download_url;
          // window.open(res.data.download_url,'_blank')
        } else {
          this.overCurtain = true;
          this.ztsan = true;
          this.ztsan_mssage = res.message
        }
        this.samplerecordBtn = false;
      });
    },
    browseHistory() {
      if (!this.getCookie('token')) return
      this.$post("/browse/save", { mediaId: this.id })
        .then()
        .catch((error) => {
          console.log(error);
        });
    },
    report() {
      this.$message({
        message: "举报成功!",
        type: "success",
      });
    },
    collection(imgSrc) {
        let data2 = {
            keywords:this.keywordss,
            user_name:this.user_name,
            user_id:this.user_id,
            img_id:this.id,
            img_type:this.mediaTypes,
            img_url:this.photoDetail.thumbnail,
            name:this.name,
            email:this.email,
            contact_person:this.contact_person,
        }
        this.$post('/es/favorite',data2)
            .then( res => {
            }).catch(errors => {
            console.log(errors);
        })
      download(imgSrc);
      if (!this.getCookie('token')) {
        return;
      }
      this.$post("/favourite/save", { mediaId: this.id })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.data,
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeTab(e) {
      this.tabIndex = e.target.getAttribute("data-num");
      this.purposeId = e.target.getAttribute("data-id");
      this.sizeType = "";
    },
    getPhotoSimilar() {
      this.isLoad = true;
      this.$post("/image/similar", { imageId: this.id })
        .then((res) => {
          if (res.code == 200) {
            this.isLoad = false;
            this.photoSimilar = res.data.result.image;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPhotoDetail() {
      this.$post("/image/detail", { imageId: this.id })
        .then((res) => {
          if (res.code == 200) {
            if (res.data.result.id) {
              window.document.title =
                "神笔Pro - " + res.data.result.description_cn;
              this.keywords = res.data.result.keywords;
              this.photoDetail = res.data.result;
              this.searchActive = res.data.result.file_type;
                if(this.searchActive === '矢量图片'){
                    this.mediaTypes = 2
                }else if(this.searchActive === '视频'){
                    this.mediaTypes = 3
                }else{
                    this.mediaTypes = 1
                }
              this.purposeTitle = res.data.result.sizes.purpose_title;
              this.purposeSize = res.data.result.sizes.purpose_size;
              this.contributor_handle = res.data.result.contributor_handle
              this.purposeId = this.purposeTitle[0][0];
            } else {
              this.$message({
                message: res.data.result.error_message,
                type: "error",
              });
            }
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    imgZoomOut() {
      this.dialogVisible = false;
    },
    translateKeywords() {
      this.translationBtnText = "翻译中...";
      if (this.translationType === 1) {
        if (this.translationCN === "") {
          this.$post("/transalte/keywords", {
            keywords: this.photoDetail.keywords,
          }).then((res) => {
            if (res.code === 200) {
              console.log(res);
              this.translationCN = res.data;
              this.keywords = res.data;
              this.translationType = 2;
              this.translationBtnText = "翻译中文";
            } else {
              this.translationBtnText = "翻译英文";
            }
          });
        } else {
          this.keywords = this.translationCN;
          this.translationType = 2;
          this.translationBtnText = "翻译中文";
        }
      } else {
        this.keywords = this.photoDetail.keywords;
        this.translationType = 1;
        this.translationBtnText = "翻译英文";
      }
    }
  },
};
</script>


<style scoped>
body {
  font-family: "Source Han Sans CN", Arial, sans-serif;
  font-size: 16px;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
a {
  text-decoration: none;
  color: #333;
}
div,
b,
p,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
li,
dl,
dd,
header,
footer {
  margin: 0;
  padding: 0;
  list-style: none;
}
em,
i,
b,
strong {
  font-style: normal;
  font-weight: normal;
}
.ct {
  text-align: center;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.pr {
  position: relative;
}
.pa {
  position: absolute;
}
.hd {
  overflow: hidden;
}
.flard {
  display: flex;
  justify-content: space-around;
}
.flbt {
  display: flex;
  justify-content: space-between;
}
.w-1200 {
  width: 1200px;
  margin: 0 auto;
}
.w-1190 {
  width: 1190px;
  margin: 0 auto;
}
/*ͷ������*/
img {
  vertical-align: top;
}
.header .logo {
  margin-top: 16px;
}
.nav li {
  margin: 0 20px;
  text-align: center;
}
.nav li.active::after {
  content: "";
  display: block;
  background: #ff9f00;
  height: 2px;
  width: 80%;
  margin: -15px auto 0;
}
.nav li.active {
  font-weight: 600;
}
.loging .kefu img,
.loging .tishi img {
  margin: 17px 20px 0;
}
.tishi {
  position: relative;
}
.tishi span.num {
  position: absolute;
  background: #e74c3a;
  border-radius: 10px;
  color: #fff;
  min-width: 20px;
  height: 20px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  top: 15px;
  right: 15px;
  padding: 0 4px;
}
.loging .user-down img {
  margin: 30px 10px 0;
}
.user-down {
  cursor: pointer;
  position: relative;
}
.jiantou {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
/*�ײ�*/
footer {
  height: 180px;
  background: #fff;
  padding: 70px 0 0;
}
footer p {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.serch {
  background: #f7f7f7;
  display: flex;
  justify-content: space-between;
  height: 50px;
  border-bottom: 2px solid #1f1f1f;
}
.xiala {
}
.dropdown {
  width: 140px;
  text-align: center;
  line-height: 48px;
  cursor: pointer;
}
.inpt {
  width: 950px;
  padding-right: 10px;
  position: relative;
}
input {
  border: none;
  height: 48px;
  line-height: 48px;
  width: 100%;
  padding-left: 40px;
  outline: none;
  background: #f7f7f7;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input:-moz-placeholder {
  color: #999999;
}
input::-moz-placeholder {
  color: #999999;
}
input:-ms-input-placeholder {
  color: #999999;
}
.icon-scrch {
  width: 110px;
  text-align: center;
  cursor: pointer;
}
.icon-scrch img {
  margin-top: 13px;
  cursor: pointer;
}
/*������*/
.xiala img {
  margin-top: 17px;
}
.inpt img {
  margin-top: 12px;
  position: absolute;
}
.dropdown {
  position: relative;
}
.dropdown_menu {
  background: #f7f7f7;
  position: absolute;
  top: 48px;
  right: 30px;
  z-index: 1000;
  display: none;
  width: 110px;
  padding: 10px 0;
  text-align: center;
  border-top: 1px solid #ddd;
}
.dropdown_menu dd {
  line-height: 34px !important;
}
.dropdown dl dd a {
  color: #333;
  line-height: 34px;
  font-size: 14px;
}
.top-arrow1,
.top-arrow2 {
  width: 0;
  height: 0;
  display: block;
  position: absolute;
  left: 30px;
  top: -17px;
  z-index: 5; /*����ie8-*/
  border-top: 8px transparent dashed;
  border-left: 6px transparent dashed;
  border-right: 6px transparent dashed;
  border-bottom: 8px white solid;
  overflow: hidden;
}
.top-arrow1 {
  border-bottom: 9px #ddd solid;
}
.top-arrow2 {
  top: -15px;
  border-bottom: 9px #f7f7f7 solid;
}
/*ͼƬ����*/
.detail {
  padding: 30px 0 90px;
}
.commonmin {
  color: #999;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}
.commonmin a {
  color: #999;
}
.img-detail {
  margin-top: 20px;
}
.imgcon-left {
  width: 550px;
}
.imgcon-left .infoClassText {
  margin-top: 16px;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  background: #e71d36;
  padding-left: 10px;
  text-align: left;
}
.imgcon-img {
  display: inline-block;
  text-align: center;
  background: #ccc;
  height: 350px;
  width: 100%;
    position: relative;
}
.imgcon-img-cover{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: none;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: bold;
}
.imgcon-img-cover div{
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
}
.imgcon-img-cover div:hover{
    background-color:rgba(0,0,0,0.2);
}
.imgcon-right {
  width: 620px;
}
.imgcon-img img {
  height: 350px;
  max-width: 100%;
    object-fit: contain;
}
.imgcon-img:hover .imgcon-img-cover{
    display: flex;
}
.imgcon-img:hover {
  cursor: zoom-in;
}
.el-dialog__wrapper >>> .el-dialog {
  width: 60%;
  display: inline-block;
  padding: 4px;
  border-radius: unset;
}
.el-dialog__wrapper >>> .el-dialog__close {
  display: block;
  background: #bbb;
  border-radius: 30px;
  color: #fff !important;
  font-size: 22px;
  width: 30px;
  height: 30px;
  line-height: 27px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}
.el-dialog__wrapper >>> .el-dialog__close:hover {
  background: #333;
}
.el-dialog__wrapper >>> .el-dialog__headerbtn {
  top: 10px;
  right: -17px;
  z-index: 11000;
}
.el-dialog__wrapper >>> .el-dialog__body,
.el-dialog__wrapper >>> .el-dialog__header {
  padding: 0;
}
.el-dialog__wrapper >>> .el-dialog__close:before {
  vertical-align: middle;
}
.el-dialog__wrapper >>> img {
  width: 100%;
}
.el-dialog__wrapper >>> img:hover {
  cursor: zoom-out;
}
.scjb {
}
.shouc,
.jubao {
  height: 30px;
  line-height: 30px;
  background: #f7f7f7;
  border-radius: 15px;
  padding: 0 10px;
  color: #999;
  font-size: 14px;
  text-align: center;
  float: left;
  margin: 20px 10px 0 0;
  cursor: pointer;
}
.shouc i,
.jubao i {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: top;
  margin-top: 4px;
}
.shouc i {
  background: url("../assets/search/scbc.png") no-repeat center;
  background-size: 100%;
}
.shouc i.click {
  background: url("../assets/search/sc1.png") no-repeat center;
}
.jubao i {
  background: url("../assets/search/jb.png") no-repeat center;
}
.shouc span.click {
  color: #ff9f00;
}
body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
} /*ȡ��˫��������ɫ*/
.img-name {
  font-size: 20px;
  font-weight: 600;
  text-align: left;
}
.xinxi {
  padding: 20px 0;
  text-align: left;
}
.xinxi span {
  display: block;
  font-size: 14px;
  color: #999999;
  height: 24px;
  line-height: 24px;
}
.tab_title {
  margin: 20px 0;
  font-weight: 600;
}
.tab_title li {
  float: left;
  margin-right: 20px;
  cursor: pointer;
  min-height: 30px;
  margin-bottom: 10px;
}
.tab_title li p {
  height: 27px;
}
.tab_title li p i {
  display: none;
  width: 80%;
  height: 3px;
  background: #ff9f00;
  margin: 3px auto;
}
.blk {
  display: block !important;
}
.none {
  display: none !important;
}

/*��ѡ��*/
.list-cont {
  display: none;
}
.checkLabel,
.checkLabelpop {
  cursor: pointer;
  height: 30px;
  line-height: 30px;
  display: block;
}
.checkLabel i,
.checkLabelpop i {
  display: inline-block;
  width: 15px;
  height: 15px;
  background: url("../assets/search/xk1.png") no-repeat center;
  vertical-align: top;
  margin: 7px 30px 0 0;
}
.checkLabel input[type="checkbox"],
input[type="radio"] {
  display: none;
}
.checkLabel input[type="radio"]:checked + i {
  background: url("../assets/search/xk.png") no-repeat center;
}
.ma {
  font-weight: 600;
  width: 70px;
}
.checkLabel span {
  display: inline-block;
}
.danweipx {
  width: 150px;
}
.unlimited {
  width: 200px;
}
.danweicm {
  width: 160px;
  color: #999;
}
.dpi {
  color: #999;
  width: 100px;
}
.geshi {
  color: #999;
}
/*���ذ�ť*/
.download a {
  display: inline-block;
  text-align: center;
  width: 160px;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0 10px;
}
.download a[disabled] {
  cursor: no-drop;
}
.download a.xiaoyang {
  background: #66cc99;
}
.download a.xiazai {
  background: #ff9f00;
}
/*����Ƽ�*/
.xiangguan {
  background: #f7f7f7;
  padding-bottom: 60px;
}
.gjc-btm {
  margin-bottom: 30px;
}
.gjc-btm p,
.tuijian p {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 25px;
  padding-top: 30px;
}
.gjc-contbg a {
  float: left;
  /* background: #fff; */
  height: 30px;
  line-height: 30px;
  margin: 7px 12px;
  /* border-radius: 5px; */
  font-size: 14px;
  /* color: #999; */
  margin-right: 8px;
  border-bottom: 1px dotted #5e5e5e;
}
/*ͼƬ�ٲ���*/

/*����*/
.overCurtain {
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  opacity: 0.7;
  background: #0e0e0e;
  display: block;
}
.ztyi {
  height: 380px;
}
.zter {
  height: 230px;
  text-align: center;
}
.ztsan {
  width: 410px !important;
  height: 250px;
}
.ztsan .sorry {
  margin: 30px 0 0px 50px;
}
SS .ztsan .sorry p {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}
.zhuangtaiqu {
  text-align: left;
  width: 480px;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  display: block;
  z-index: 1111;
  background: #fff;
  padding: 25px 30px;
  font-size: 14px;
  border-radius: 10px;
}
.zhuangtaiqu p.hd img.fr {
  cursor: pointer;
}
.souquan p {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}
.zter .tianxiesq-tow {
  width: 380px;
  margin: 35px 20px 20px;
  padding: 0 25px;
}
input.tianxiesq,
.tianxiesq-tow {
  border: none;
  height: 36px;
  line-height: 36px;
  width: 220px;
  padding: 0 15px;
  outline: none;
  border-radius: 18px;
}
input::-webkit-input-placeholder {
  color: #999999;
}
input:-moz-placeholder {
  color: #999999;
}
input::-moz-placeholder {
  color: #999999;
}
input:-ms-input-placeholder {
  color: #999999;
}
.serch-btn {
  width: 70px;
  height: 36px;
  text-align: center;
  background: #ff9f00;
  border-radius: 18px;
  margin: 0 10px;
  display: inline-block;
  cursor: pointer;
}
.serch-btn img {
  width: 20px;
  height: 22px;
  margin-top: 8px;
}
.tjsq {
  display: inline-block;
  padding: 0 15px;
  text-align: center;
  height: 36px;
  line-height: 36px;
  color: #3377aa;
  background: #e7f0f9;
  border: 1px solid#D8E5F2;
  border-radius: 18px;
  cursor: pointer;
}
.sqgs {
  margin-top: 20px;
    height: 150px;
    overflow: auto;
}
.checkLabelpop {
  font-size: 14px;
  height: 36px;
  line-height: 36px;
}
.checkLabelpop i {
  margin-right: 10px !important;
  margin-top: 10px;
}
.zhuansq {
  color: #3377aa;
  display: inline-block;
  margin-left: 10px;
}
.queding a {
  display: inline-block;
  padding: 0 30px;
  color: #fff;
  height: 36px;
  line-height: 36px;
  background: #ff9f00;
  border-radius: 18px;
  margin-top: 15px;
}
.zter .queding a {
  padding: 0 40px;
}
.ztsan .queding a {
  margin-left: 70px;
}

.checkLabel {
  text-align: left;
}
.ct {
  margin-top: 30px;
}
.pubu-img {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}
.pubu-img ul {
  display: flex;
  flex-wrap: wrap;
}
.pubu-img ul li {
  flex-grow: 1;
  margin: 4px;
  /*background: url("../assets/search/loading.gif") no-repeat center center;*/
  height: 200px;
}
.pubu-img ul li:last-child {
  flex-grow: unset;
}
.pubu-img ul img {
  height: 200px;
  object-fit: cover;
  max-width: 100%;
  min-width: 100%;
  vertical-align: bottom;
}
.xinxi .detail-bubble {
  display: inline-block;
  width: 18px;
  margin-left: 8px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAFJtetpAAAABGdBTUEAALGPC/xhBQAABWRJREFUWAnVV11oXEUUPjO7m2x276Ya27S1KUbTVoqtCUmI+lakJT+mtEjF16YiVsUWhYogKFKf/EHwB+mDWpUKNYjFh2yifWlBRJpsrIEQq/iDIamtxpK9d/OzuzOeM5vZndm9m13jkxd25/x858y5M3POmQuw8rhj3X8QGaS/5Gi3DK7fjyNIRhopoREY6mSG9DmExIeQOUnxvzvWc3ZxvH87yVkxjOfRPKLIgkCkyOB4HqAJRkQq0XsoK8SgFuox1jnCOM2olU7HsNLpkQJgFE46m76iraKtZ8G7/LBmQU1BXHG4FFCsc/jNPEAmejd4Qoyh4nunc7hfu1CAUmuEMfYqxvIsN5W8rhkgEFPGuJYniDCWipzZi8uAXS2s1IpSvyJZS5CbDAD5qwFcF9Kph3P+CA9A4F4tCG18UJNqjLbH31dv4Sa690oBX5laWmaTL0tbqNR3/VuymfR0WTQqKKRI59C3GqMcVGOoDfTIOOxz2kfOM9oiV4hrWqHHaNtnkJm7CJm/L0K45QVYmj4FmT9zp0VjcIUOMne053dczyYtVCMLYRrEQKbnFEs7WLfzHfASD1gwYmgfLpdIZTpvTBsnlmZ9jXHj5tUamOelxNkqApURpCeCTt8qWFvF2AW9z9Y2apQ33n1AZtm7uDabczI2zzl7mk6OxujR14E71jcAMnsUk6INpJzEpTrjdMZf00bmaDlIjvZ8imf8IRNg0vial3BRuyyZZjALFjHJajW/2qjfnzAqnfAszFZrTEaIXymU6ACPcRclJinsh0Pw5j0QqO+wxcghPuAmep4hBRfZzDfFCBZqAKdjCNcvDTyyA2n7CBNeCvk6jUEM3a4KKIzsOg3exGGQy1chC19D6Jb7sVhsUjwZmU+JMSlTk49ZYB7eiu1h3rRT9MJ4T7OvA4lnXz+UiVlvCkCVfy3NjYzxGtWWbHGBCzUeBBZaDwtTxwpCgwq3DV1Z1UFN06NlsrDghWN7KLSKglxRfvmvIZzB20Sro4yncAl3o0Yr9Ujbl5o6DsL7QYvyoz6N+Vz4NzXBWcfDbHt8ibzlHRCDkfyKkdxGtP/Dktjz6k2dtY0YcrOzsT7CGHxggjCtv3A4byw2tjBrZaxX8HNCySYymZP4snv9jr2fDbbVCcnky0778CDWELvnFhn4BpAa7btHgDjnn+VFHiqwGMAy/h73K6dkagWgJmbiAr5pVYWtwtylas6Pxdrjb5mKfACVyrFp9F9oXI3fovXsTusYu6PdX+JG7avGMau9FcLNJyDg7LTgMuvB8szHkL52zpKXYebwtDexrYMLeCXuG5AyW9Lu/Axrb38OQg17YGnmI0jPfmJBuLMb6na8Alj68CJ6yNL5MZRqTsfIEa7apx+iSEYFnSYXi9MlkxNUuBMgFn7BO42DXWRbkXUpi98BA/LH3trgSu8uRRRJqLuY909LjR8U4W0vQSByB6Svx7H0/2SpyzELXqA1mLs4QFs5UCV5uOVFCN50H2TmE+COH8ClUCWykpnS14XqJrGf8DNotaYA6MoYiLRgC30Cl//nqibNg7C8srsGXZWGmAUTmAW78spqCB6G0Ib92KtvQOYv635f0RonTUc538La49dVM4h2DN+N+XmpoqUBYMF1+NWzGwJRSsd8OTEQ5UiWlKFIE01OCNXScXKq111eoveIEOK9cqamnAUiwLEmCPqixQ8GzCZT7Utjj/gQv/QOm0rf0JOJ3qeYkG/QDc4Er5XGFzyN1e+orn6mH98ANIDy1EvKJ/EW+DzKGrS80kh7jIXmlAhGTsZaPy/5gDLtVw3ABJo0Bbboys2SBRs5iBu1oegMnWgT87+h/wErb/5JJxGYSAAAAABJRU5ErkJggg==)
    no-repeat 50%;
  background-size: 18px;
  height: 100%;
  vertical-align: middle;
  position: relative;
}
.xinxi .detail-bubble:hover > .solt_contnet {
  display: inline-block;
}
.xinxi .solt_contnet {
  display: none;
  width: 250px;
  height: 110px;
  box-shadow: 2px 5px 8px #dddddd;
  position: absolute;
  left: -125px;
  top: -120px;
  background: #ffffff;
  border: 1px solid #dddddd;
  padding: 8px;
  color: #666666;
}
.xinxi .solt_contnet:before {
  display: block;
  position: absolute;
  left: 125px;
  bottom: -8px;
  content: "";
  width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
  height: 0px;
  border-left: 10px solid transparent;
  border-top: 10px solid #fff;
  border-right: 10px solid transparent;
}
.detail-title {
  display: flex;
  justify-content: space-between;
}
.translation-btn {
  width: 96px;
  height: 32px;
  background: #fff;
  border-radius: 2px;
  border: 1px solid #333;
  font-size: 14px;
  color: #333;
  line-height: 32px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  margin-top: 30px;
}
.progress {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 300px;
  color: #fff;
}
.price-tip {
  color: #ff9f00;
  font-size: 14px;
  margin-top: 8px;
}
</style>
